import type { FC } from 'react';
import { Box } from '@material-ui/core';
import Chart from 'react-apexcharts';
import Title from 'src/components/admin/Title';

interface PropsSeguimientoCierreMeta {
  cierre: { amountProject: number; amountFinish: number };
}

const SeguimientoCanal: FC<PropsSeguimientoCierreMeta> = ({ cierre }) => {
  const title = 'Cierre vs Meta de Canal, En MM de PEN y %';
  const chart = {
    options: {
      chart: {
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      colors: ['#bde5ff', '#166aaa'],
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '16px',
          colors: ['#304758', 'white'],
        },
      },
      xaxis: {
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
        categories: ['Proy. Cierre', 'Meta Final'],
      },
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
      legend: {
        show: false,
      },
    },
    series: [
      {
        name: 'Valor',
        data: [cierre.amountProject, cierre.amountFinish],
      },
    ],
  };

  return (
    <Box p={2} height="250px" maxHeight="250px">
      <Title title={title} />
      <Chart type="bar" height="200px" {...chart} />
    </Box>
  );
};

export default SeguimientoCanal;
